import AuthDescription from "../AuthDescription";
import { Outlet } from "react-router-dom";
import Copyright from "@/components/layout/Footer/Copyright";

const AuthLayout = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full min-h-screen">
      {/* {isSpecialRoute &&
                <div className="flex items-center justify-between w-full p-4 md:p-6">
                    <img src={Logo} alt="Logo" className="h-8 md:h-10" />
                    <div>
                        <p className="flex items-center gap-1 text-xs">
                            <span className="hidden sm:block">Have an Existing Veegil SSO Account? </span> 
                            <Link to="/signin" className="text-base font-bold sm:text-xs text-bold text-primary hover:text-hover">Sign In</Link></p>
                    </div>
                    
                </div>
            } */}
      <div className="flex items-center justify-center gap-10">
        <div className="flex-1">
          <Outlet />
        </div>
        <AuthDescription />
      </div>
      <div className="my-5">
        <Copyright />
      </div>
    </div>
  );
};

export default AuthLayout;
